<template>
    <template v-for="node in rows" :key="node.key">
        <tr>
            <td class="cw-toggle position-relative">
                <a href v-if="node.rows && node.rows.length" class="widget-toggle-wrapper collapse-trigger" role="button" :style="toggleStyle" :class="{'is-expanded': isExpanded(nodePath(node))}" @click.prevent="toggle(nodePath(node))">
                    <collapse-toggle-button />
                </a>
            </td>
            <td :style="nameStyle">{{ node.name }}</td>
            <td class="text-right">{{ displayQty(node.hours) }}</td>
            <td class="text-right">{{ displayQty(node.units) }}</td>
            <td class="text-right">${{ node.amount }}</td>
        </tr>
        <labor-allocation-rows v-if="node.rows && node.rows.length && isExpanded(nodePath(node))" :rows="node.rows" :depth="depth + 1" :path-prefix="nodePath(node)" :is-expanded="isExpanded" :toggle="toggle" />
    </template>
</template>

<script>
// Recursive renderer for a tree of Labor Allocation rows (e.g. tax/deduction items, each
// expandable to its positions). Expansion is controlled from LaborAllocation via the
// is-expanded / toggle accessors, keyed by full path so siblings can share the same parent.
export default {
    name: 'LaborAllocationRows',
    props: {
        rows: {
            type: Array,
            default: function () { return [] },
        },
        depth: {
            type: Number,
            default: 1,
        },
        pathPrefix: {
            type: String,
            default: '',
        },
        isExpanded: {
            type: Function,
            required: true,
        },
        toggle: {
            type: Function,
            required: true,
        },
    },
    computed: {
        nameStyle() {
            return { paddingLeft: (this.depth * 1.5) + 'rem' }
        },
        // Inset the expand toggle along with the name so sub-rows read as lower in the hierarchy.
        // translateX (rather than padding) because the toggle is absolutely positioned in its
        // table cell, where cell padding doesn't reliably move it.
        toggleStyle() {
            return { transform: 'translateX(' + (this.depth * 1.5) + 'rem)' }
        },
    },
    methods: {
        nodePath(node) {
            return this.pathPrefix + '/' + node.key
        },
        // Blank out a zero quantity so the Hours / Units columns read empty rather than "0.00".
        displayQty(value) {
            return parseFloat(value) === 0 ? '' : value
        },
    },
}
</script>
